import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { PriorityDownloadModalProps } from 'reactApp/ui/PriorityDownloadModal/PriorityDownloadModal';

export const openPriorityDownloadModal = (data: PriorityDownloadModalProps) =>
    openPopupHelper({ popupName: popupNames.PRIORITY_DOWNLOAD_MODAL, data });

export const closePriorityDownloadModal = () => closePopupHelper(popupNames.PRIORITY_DOWNLOAD_MODAL);
